import React, { useState } from 'react';
import { Form, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { ArrowRight } from 'react-bootstrap-icons';

const Step1Client = ({ onNext, data, updateFormData }) => {
  const [ruc, setRuc] = useState(data.ruc || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [clientFound, setClientFound] = useState(!!data.name);

  const handleRucLookup = async () => {
    if (!ruc || loading) {
      return;
    }
    if (clientFound && ruc === data.ruc) {
      return;
    }

    setLoading(true);
    setError('');
    setClientFound(false);

    let foundClientData = null;

    for (const type of [2, 1]) {
      try {
        const response = await fetch(`https://hub.efacturapty.com/Estimate/Taxpayer/${type}/${ruc}`);
        if (response.ok) {
          const result = await response.json();
          if (result && result.name) {
            foundClientData = {
              ...result,
              type: type === 1 ? 'Natural' : 'Juridico',
            };
            break;
          }
        }
      } catch (err) {
        console.error(`Error fetching for type ${type}:`, err);
      }
    }

    setLoading(false);
    if (foundClientData) {
      updateFormData({
        ...data,
        ...foundClientData,
        ruc: foundClientData.ruc || ruc,
      });
      setClientFound(true);
    } else {
      setError('El RUC no fue encontrado o es inválido. Por favor, verifique el número.');
      updateFormData({
        ...data,
        dv: '',
        type: '',
        name: '',
      });
    }
  };

  const handleRucChange = (e) => {
    const newRuc = e.target.value;
    setRuc(newRuc);
    if (clientFound) {
      setClientFound(false);
      setError('');
    }
    updateFormData({
      ...data,
      ruc: newRuc,
      dv: '',
      type: '',
      name: '',
    });
  };

  const handleFieldChange = (e) => {
    updateFormData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const isNextDisabled = !clientFound || !data.email;

  return (
    <div className="p-4">
      <div className="wizard-header">
        <h4 className="mb-0">Datos del Cliente</h4>
      </div>
      <Form>
        <Row className="mb-3 g-3">
          <Form.Group as={Col} sm={8} controlId="ruc">
            <Form.Label>
              RUC
              {loading && <Spinner as="span" animation="border" size="sm" className="ms-2" />}
            </Form.Label>
            <Form.Control
              type="text"
              value={ruc}
              onChange={handleRucChange}
              onBlur={handleRucLookup}
              disabled={loading}
            />
          </Form.Group>
          <Form.Group as={Col} sm={4} md={4} controlId="dv">
            <Form.Label>DV</Form.Label>
            <Form.Control
              type="text"
              readOnly
              disabled={!clientFound}
              value={data.dv || ''}
              maxLength={2}
            />
          </Form.Group>
        </Row>

        {error && <Alert variant="danger">{error}</Alert>}

        <Row className="mb-3 g-3">
          <Form.Group as={Col} sm={8} controlId="name">
            <Form.Label>Nombre / Razón Social</Form.Label>
            <Form.Control type="text" readOnly disabled={!clientFound} value={data.name || ''} />
          </Form.Group>

          <Form.Group as={Col} sm={4} md={4} controlId="type">
            <Form.Label>Tipo</Form.Label>
            <Form.Control type="text" readOnly disabled={!clientFound} value={data.type || ''} />
          </Form.Group>
        </Row>

        <Row className="mb-3 g-3">
          <Form.Group as={Col} sm={8} controlId="email">
            <Form.Label>Correo Electrónico</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={data.email || ''}
              onChange={handleFieldChange}
            />
          </Form.Group>

          <Form.Group as={Col} sm={4} md={4} controlId="telefono">
            <Form.Label>Teléfono</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={data.phone || ''}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </Row>

        {clientFound && data.type === 'Juridico' && (
          <Form.Group as={Row} className="mb-3" controlId="contactPerson">
            <Form.Label>Nombre de Contacto</Form.Label>
            <Col>
              <Form.Control
                type="text"
                name="contactPerson"
                value={data.contactPerson || ''}
                onChange={handleFieldChange}
              />
            </Col>
          </Form.Group>
        )}

        <div className="d-flex justify-content-end mt-4">
          <Button
            onClick={onNext}
            disabled={isNextDisabled}
            variant="primary"
            className="d-inline-flex align-items-center gap-2"
          >
            Siguiente
            <ArrowRight size={18} />
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Step1Client;
